<template>
  <v-list class="pt-0" dense>
    <v-divider></v-divider>

    <v-list-item router to="/">
      <v-list-item-action>
        <v-icon>dashboard</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          Painel
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <template v-for="area in areas">
      <v-list-item
        v-if="!area.items || area.items.length == 0"
        router
        :key="area.title"
        :to="area.route"
      >
        <v-list-item-action>
          <v-icon>{{ area.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ area.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        v-else
        :key="area.title"
        :append-icon="$vuetify.icons.expand"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon>{{ area.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ area.title }}</v-list-item-title>
        </template>
        <v-list-item
          router
          v-for="item in area.items"
          :key="item.title"
          :to="item.route"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </template>

    <v-divider></v-divider>
    <v-list-item @click="logout">
      <v-list-item-action>
        <v-icon>exit_to_app</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          Sair
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      areas: [
        { title: "Clientes", icon: "favorite", route: "/customers" },
        { title: "Contratos", icon: "class", route: "/contracts" },
        { title: "Excursões", icon: "public", route: "/groupTrips" },
        { title: "Financeiro", icon: "attach_money", route: "/accounting" },
        {
          title: "Configurações",
          icon: "settings",
          items: [
            { title: "Empresa", icon: "business", route: "/company" },
            { title: "Unidades", icon: "location_on", route: "/branches" },
            { title: "Usuários", icon: "people", route: "/users" }
          ]
        }
      ]
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
</script>
